import styled from "@emotion/styled";
import { ReactNode } from "react";

export const BannerPage = (props: {
    title?: string;
    children: ReactNode;
    slim?: boolean;
}) => {
    const content = (
        <>
            {props.title !== undefined && (
                <Title slim={props.slim ?? false}>{props.title}</Title>
            )}
            {props.children}
            <BottomPadding slim={props.slim ?? false} />
        </>
    );

    return (
        <Container>
            <Page slim={props.slim ?? false} className="lg:w-[90%]">
                {props.slim ? <>{content}</> : <div>{content}</div>}
            </Page>
            <Banner className="md:hidden lg:block lg:w-[10%]">
                <Gradient />
            </Banner>
        </Container>
    );
};

const Container = styled("div")({
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "row"
});

const Page = styled("div")<{ slim: boolean }>(({ slim }) => ({
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    paddingLeft: 40,
    paddingRight: 40,
    overflow: "auto",
    alignItems: slim ? undefined : "center"
}));

const Title = styled("h1")<{ slim: boolean }>(({ slim, theme }) => ({
    marginTop: slim ? 30 : 67,
    marginBottom: slim ? 30 : 57,
    fontSize: theme.fontSizes.veryLarge,
    fontWeight: "normal",
    color: theme.foregroundTitle
}));

const BottomPadding = styled("div")<{ slim: boolean }>(({ slim }) => ({
    height: slim ? 30 : 67,
    flexShrink: 0
}));

const Banner = styled("div")({
    background: "#5e5e5e",
    position: "relative"
});

const Gradient = styled("div")({
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: "radial-gradient(50% 50% at 50% 50%, #60788f 0%, #42617D 100%);"
});
